import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';

export interface Views {
  period: Date;
  start: Date;
  end: Date;
  count: number;
}

interface Articles {
  count: number;
  views: Views[];
}

interface Authors {
  count: number;
  views: Views[];
}

interface Categories {
  count: number;
  views: Views[];
}

interface Errors {
  count: number;
}

interface Metrics {
  count: number;
}

interface Surveys {
  count: number;
  views: Views[];
}

export interface Dashboard {
  articles: Articles;
  authors: Authors;
  categories: Categories;
  errors: Errors;
  metrics: Metrics;
  surveys: Surveys;
}

export class DashboardService extends AuthenticatedService {
  dashboard = async (): Promise<IHttpResponse<Dashboard>> => {
    const dashboardData = await this.getAuth<Dashboard>(
      'dashboard',
    );

    return dashboardData;
  }
}
